import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { first } from "rxjs/operators";
import { BuildingGroupAddBuildingToGroupComponent } from "../building-group-add-building-to-group/building-group-add-building-to-group.component";
import { BuildingGroupAddBuildingToNewGroupComponent } from "../building-group-add-building-to-new-group/building-group-add-building-to-new-group.component";

@Component({
  selector: "app-building-group-select",
  templateUrl: "./building-group-select.component.html",
  styleUrls: ["./building-group-select.component.scss"],
})
export class BuildingGroupSelectComponent implements OnDestroy {
  @Input() buildings;
  @Input() areaId: string;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() reloadBuildingList: EventEmitter<any> = new EventEmitter();

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal
  ) {}

  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  openAddToExistingGroupModal() {
    const modalRef = this.modalService.open(
      BuildingGroupAddBuildingToGroupComponent,
      {
        size: "lg",
      }
    );
    modalRef.componentInstance.areaId = this.areaId;
    modalRef.componentInstance.reloadBuildingList = this.reloadBuildingList;
    modalRef.componentInstance.buildings = this.buildings;
    modalRef.componentInstance.passEntry.pipe(first()).subscribe((data) => {
      this.passEntry.emit(data);
      this.modalService.dismissAll();
    });
    modalRef.result.then(
      (result) => {
        if (result === "open-add-to-new-modal") this.openAddToNewGroupModal();
      },
      (reason) => {
        this.modalService.dismissAll();
      }
    );
  }

  openAddToNewGroupModal() {
    const modalRef = this.modalService.open(
      BuildingGroupAddBuildingToNewGroupComponent,
      {
        size: "lg",
      }
    );
    modalRef.componentInstance.buildings = this.buildings;
    modalRef.componentInstance.areaId = this.areaId;
    modalRef.componentInstance.reloadBuildingList = this.reloadBuildingList;

    modalRef.componentInstance.passEntry.pipe(first()).subscribe((data) => {
      this.passEntry.emit(data);
      this.modalService.dismissAll();
    });

    modalRef.result.then(
      (result) => {
        if (result === "open-add-to-existing-modal")
          this.openAddToExistingGroupModal();
      },
      (reason) => {
        this.modalService.dismissAll();
      }
    );
  }
}
